import { useCallback, useState } from 'react';
import localStorageService, { LocalStorageKeys } from '../../../services/localStorageService';

export const useSidebarState = (isMobile: boolean) => {
  const [desktopOpen, setDesktopOpen] = useState<boolean>(() => {
    try {
      return localStorageService.get<boolean>(LocalStorageKeys.CachedDesktopSidebarOpen) ?? false;
    } catch {
      return false;
    }
  });

  // Mobile drawer state — ephemeral, never persisted
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);

  const sidebarOpen = isMobile ? mobileOpen : desktopOpen;

  const handleSidebarToggle = useCallback(
    (open: boolean) => {
      if (isMobile) {
        setMobileOpen(open);
        return;
      }
      setDesktopOpen(open);
      try {
        localStorageService.save(LocalStorageKeys.CachedDesktopSidebarOpen, open);
      } catch {
        // ignore write failures — sidebar state is non-critical
      }
    },
    [isMobile]
  );

  return { sidebarOpen, handleSidebarToggle };
};
